import { List, message, Switch } from "antd";
import { FC, useState } from "react";
import CollapseCard from "../../../components/collapseCard";
import DealerStore from "../../../contexts/dealerStore";
import _t from "../../../lang/translate";
import { togglePartnership } from "../../../services/dealerService";
import { partnershipGroupsUrl } from "../../../services/miscService";
import { useApi } from "../../../services/useApi";
import { PartnershipGroup } from "../../../types/appTypes";

const DealerPartnershipGroupCard: FC = () => {
  const { dealer, setDealer, isAdmin, isNew } = DealerStore.useContainer();
  const [{ data, isLoading }] = useApi<{ data: PartnershipGroup[] }>(partnershipGroupsUrl, { data: [] });
  const [togglingId, setTogglingId] = useState<number | null>(null);

  if (!isAdmin || isNew) return null;

  const groups = data?.data || [];

  const handleToggle = async (groupId: number) => {
    setTogglingId(groupId);
    try {
      await togglePartnership(dealer.id, { partnershipGroupId: groupId });

      const currentGroups = dealer.partnershipGroups || [];
      const exists = currentGroups.find(g => g.id === groupId);

      let nextGroups;
      if (exists) {
        nextGroups = currentGroups.filter(g => g.id !== groupId);
      } else {
        const groupInfo = groups.find(g => g.id === groupId);
        if (groupInfo) {
          nextGroups = [...currentGroups, groupInfo];
        } else {
          nextGroups = currentGroups;
        }
      }

      setDealer({ ...dealer, partnershipGroups: nextGroups });
      message.success(_t("saved"));
    } catch (error) {
      // Error is already handled by httpService/useApi showing a message
    } finally {
      setTogglingId(null);
    }
  };

  return (
    <CollapseCard title={_t("partnership_groups")} loading={isLoading} defaultOpen={false}>
      <List
        dataSource={groups}
        renderItem={(group) => {
          const isJoined = !!dealer.partnershipGroups?.find((g) => g.id === group.id);
          return (
            <List.Item
              actions={[
                <Switch
                  key="toggle"
                  checked={isJoined}
                  loading={togglingId === group.id}
                  onChange={() => handleToggle(group.id)}
                />,
              ]}
            >
              <span
                style={{
                  textDecoration: group.isActive ? "none" : "line-through",
                  opacity: group.isActive ? 1 : 0.5,
                }}
              >
                {group.name}
              </span>
            </List.Item>
          );
        }}
      />
    </CollapseCard>
  );
};

export default DealerPartnershipGroupCard;
